import { useEffect } from "react";

export default function Join() {
  useEffect(() => {
    window.location.href =
      "https://forms.gle/PA5P1QaDnitkPuru6";
  }, []);

  return (
    <div style={{padding:"20px", textAlign:"center"}}>
      Opening form...
    </div>
  );
}